import { Skeleton } from 'antd';
import { useAuth } from 'lib/hooks/auth/use-auth';
import useSearchParams from 'lib/hooks/use-searchParams';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  useCheckOnboardingStatusMutation
} from '../_hooks/useClaimOnboardingTokenMutation';
import LandingPage from './landing_page';

export default function OnboardingLandingPage() {
  const history = useHistory();
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const checkStatusMutation = useCheckOnboardingStatusMutation();

  useEffect(() => {
    if (auth.user && token) {
      checkStatusMutation.mutate(token, {
        onSuccess: (res: any) => {
          const status = res.data?.status;
          if (status === 'USER_ALREADY_IN_ORGANISATION') {
            history.push('/');
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.user, token]);

  if (auth.isLoading || checkStatusMutation.isPending) {
    return <Skeleton active />;
  }

  return <LandingPage />;
}
